export var ViewPortSizes;
(function (ViewPortSizes) {
    ViewPortSizes[ViewPortSizes["s"] = 576] = "s";
    ViewPortSizes[ViewPortSizes["m"] = 768] = "m";
    ViewPortSizes[ViewPortSizes["l"] = 992] = "l";
    ViewPortSizes[ViewPortSizes["xl"] = 1200] = "xl";
})(ViewPortSizes || (ViewPortSizes = {}));
